import loglevel from "loglevel";

const log = loglevel.getLogger("orai.js");
log.disableAll();

export default log;
